import { atom } from "jotai";
import { ConfirmationResult } from "@react-native-firebase/auth";
import { safeAsyncStorage } from "../utils/safe-async-storage";

// LEGACY COMMENT (recoil era)
// we need to allow mutability because the confirmation result method is broken
// if we let de default value be immutable
export const phoneNumberConfirmResult = atom<ConfirmationResult>();

export const signupInvitationIdsToIgnore = atom<string[]>([]);

export const PENDING_INVITATION_CODE_KEY = "auth.pendingInvitationCode";

const pendingInvitationCodeValue = atom<string | null>(null);

// Restore a code stored before an app restart, unless one was set in the meantime.
pendingInvitationCodeValue.onMount = (setValue) => {
    void safeAsyncStorage.getItem(PENDING_INVITATION_CODE_KEY).then((storedCode) => {
        if (storedCode) {
            setValue((currentCode) => currentCode ?? storedCode);
        }
    });
};

/**
 * The code of an email invitation, opened from its link while signed out: the signup prefills the
 * invitation code step with it. Kept in storage so that it survives an app restart mid-signup; set
 * it back to `null` once it is used or the user skips the step.
 */
export const pendingInvitationCode = atom(
    (get) => get(pendingInvitationCodeValue),
    (_get, set, code: string | null) => {
        set(pendingInvitationCodeValue, code);
        if (code) {
            void safeAsyncStorage.setItem(PENDING_INVITATION_CODE_KEY, code);
        } else {
            void safeAsyncStorage.removeItem(PENDING_INVITATION_CODE_KEY);
        }
    },
);

/**
 * Whether the signup went through the invitation code step (a code was found, or the user has
 * none): the role selection then stops sending to it. Reset when the Firebase user signs out.
 */
export const invitationCodeStepDone = atom(false);
